// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"0d44d1f4","448":"0d44d1f4","526":"0d44d1f4"}[chunkId] + ".chunk.css";
};